import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'lv_LV',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '3a46067d-4970-44a4-b316-f0c22280c2cc',
  ''
);
